import { render, staticRenderFns } from "./FeeFileConfigureAddDalog.vue?vue&type=template&id=6d2f53f3&scoped=true&"
import script from "./FeeFileConfigureAddDalog.vue?vue&type=script&lang=js&"
export * from "./FeeFileConfigureAddDalog.vue?vue&type=script&lang=js&"
import style0 from "./FeeFileConfigureAddDalog.vue?vue&type=style&index=0&id=6d2f53f3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2f53f3",
  null
  
)

export default component.exports